import styled from 'styled-components';

export const FloatingButton = styled.a`
  position: fixed;
  bottom: 40px;
  right: 40px;
  background-color: #25D366;
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  text-align: center;
  font-size: 30px;
  box-shadow: 2px 2px 3px #999;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background-color: #128C7E;
    transform: scale(1.1);
  }
`;
